enum Classes {
  MARINE = 'MARINE',
  ANDROID = 'ANDRIOD',
  TEAMSTER = 'TEAMSTER',
  SCIENTIST = 'SCIENTIST',
}
export default Classes
